"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  removePlugins: ['about', 'elementspath', 'removeformat'],
  removeButtons: 'Anchor',
  extraPlugins: 'justify'
};
exports.default = _default;